import React, { useMemo } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Label,
} from "recharts";
import { BarChart3 } from "lucide-react";

const hasValidData = (data) => {
  if (!data?.labels?.length || !data?.data?.length) return false;

  return data?.data.some(
    (value) => typeof value === "number" && !Number.isNaN(value),
    // &&
    // value > 0
  );
};

const NPLineChart = ({ data }) => {
  // Transform API data -> chart format
  const chartData = useMemo(() => {
    if (!hasValidData(data)) return [];

    return data?.labels?.map((label, index) => {
      const month = new Date(label).toLocaleString("default", {
        month: "short",
      });

      return {
        month,
        value: data.data[index],
      };
    });
  }, [data]);

  const hasData = chartData.length > 0;

  // Handle empty state
  if (!hasData) {
    return (
      <div className="w-full h-[300px] flex flex-col items-center justify-center border border-gray-200 rounded-lg bg-gray-50">
        <BarChart3 className="w-10 h-10 text-[#074043] mb-2" />
        <p className="text-[#074043] text-lg">No data available</p>
      </div>
    );
  }

  return (
    <ResponsiveContainer width="99%" height={300}>
      <LineChart
        data={chartData}
        margin={{ top: 20, right: 30, left: 50, bottom: 20 }}
      >
        <CartesianGrid strokeDasharray="3 3" />

        <XAxis dataKey="month" axisLine={{ stroke: "#D9D9D9" }}>
          <Label value="Months" position="insideBottom" offset={-20} />
        </XAxis>

        <YAxis
          domain={[0, 100]}
          ticks={[0, 25, 50, 75, 100]}
          axisLine={{ stroke: "#D9D9D9" }}
        />

        <Tooltip />

        <Line
          type="linear"
          dataKey="value"
          stroke="#005C53"
          strokeWidth={1}
          dot={{ r: 4 }}
          activeDot={{ r: 6 }}
        />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default NPLineChart;
